import IdGenerator from 'scripts/domain/contracts/id_generator';

import { handleCommonErrors } from 'scripts/application/lib/gateway_error_silent_handler';
import TeamAssistMessage from 'models/team_assist_message';

export default class AskTeamAssist {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, question, displayedMessage }) {
    if (!customerId) {
      return;
    }
    if (!question) {
      return;
    }

    if (!this.context.stores.customers.has({ id: customerId })) {
      return;
    }

    const { teamAssists } = this.context.stores.customers.storesFor(customerId);

    const messageId = IdGenerator.newId();
    const optimisticMessage = TeamAssistMessage.create({
      content: question,
      createdAt: new Date().toISOString(),
      customerId,
      displayedMessage,
      id: messageId,
      role: TeamAssistMessage.Role.agent_question,
      type: TeamAssistMessage.Type.question,
    });
    teamAssists.addOrReplace(optimisticMessage);
    teamAssists.setLoading();

    const body = { id: messageId, question };
    if (displayedMessage) {
      body.displayedMessage = displayedMessage;
    }

    this.context.gateways.teamAssist
      .add({ customerId }, body)
      .catch(err => {
        const msg = teamAssists.find(messageId);
        if (msg) {
          teamAssists.addOrReplace(TeamAssistMessage.fromJs({ ...msg.toJs(), error: true }));
        }
        handleCommonErrors(this.context, err);
      })
      .finally(() => {
        teamAssists.resetLoading();
      });
  }
}
